// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"240":"71aef896d3696fbc448b","524":"ee4db97540c0001bc2cc"}[chunkId] + ".css";
};